import { getCache, setCache } from '@/util/cache'
// TODO 好多接口应该放到这里 action的 返回promise
/* eslint-disable */
const app = {
  state: {
    animal_types: getCache('animal_types') || [
      {
        'id': 0,
        'name': '未分类'
      },
      {
        'id': 1,
        'name': '不是绿孔雀'
      },
      {
        'id': 2,
        'name': '是绿孔雀'
      },
      {
        'id': 3,
        'name': '误拍'
      },
      {
        'id': 4,
        'name': '人类及家畜'
      },
      {
        'id': 5,
        'name': '其他野生动物'
      }
    ],
    animal_genders: getCache('animal_genders') || [
      {
        value: 0,
        text: '未知'
      },
      {
        value: 1,
        text: '雄性'
      },
      {
        value: 2,
        text: '雌性'
      },
      {
        value: 3,
        text: '幼体'
      }
    ],
    county_code_list: getCache('county_code_list') || [],
    area_code_list: getCache('area_code_list') || [],
    area_code_for_county: getCache('area_code_for_county') || {}
  },
  mutations: {
    SET_ANIMAL_TYPES: (state, animal_types) => {
      setCache('animal_types', animal_types)
      state.animal_types = animal_types
    },
    SET_COUNTY_CODE_LIST: (state, county_code_list) => {
      setCache('county_code_list', county_code_list)
      state.county_code_list = county_code_list
    },
    SET_AREA_CODE_LIST: (state, area_code_list) => {
      setCache('area_code_list', area_code_list)
      state.area_code_list = area_code_list
    },
    SET_AREA_CODE_FOR_COUNTY: (state, area_code_for_county) => {
      setCache('area_code_for_county', area_code_for_county)
      state.area_code_for_county = area_code_for_county
    },
  },
  actions: {}
}

export default app
